"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
require("antd/dist/antd.css");
var _reactRouterDom = require("react-router-dom");
var _navigationDrawer = _interopRequireDefault(require("../navigation-drawer/navigation-drawer"));
var _ScrollableContainer = _interopRequireDefault(require("../scrollbars/ScrollableContainer.js"));
var _allAppsItems = require("../allAppsItems.js");
var _leftMenu = _interopRequireDefault(require("../navigation-drawer/left-menu.js"));
var _Layout = _interopRequireDefault(require("../Layout.js"));
var _turingFooter = _interopRequireDefault(require("../turing-footer/turing-footer"));
var _turingHeader = _interopRequireDefault(require("../turing-header/turing-header.js"));
require("./default-view.css");
var _antd2 = require("antd");
var _Icon = _interopRequireDefault(require("@material-ui/core/Icon"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
var modalContent = "";
var message = /*#__PURE__*/_react["default"].createElement("div", {
  style: {
    padding: "10px 20px",
    margin: "10px",
    borderRadius: "5px",
    border: "1px solid #ff8888",
    backgroundColor: "#ffeeee",
    fontSize: "12px"
  }
}, "Attention! We a going to update our website", " ", /*#__PURE__*/_react["default"].createElement("b", null, "this Sunday at 3am-5am PDT"), "! Have a nice sleep at this time!", " ");
var DefaultView = /*#__PURE__*/function (_React$Component) {
  _inherits(DefaultView, _React$Component);
  var _super = _createSuper(DefaultView);
  function DefaultView(props) {
    var _this;
    _classCallCheck(this, DefaultView);
    _this = _super.call(this, props);
    _this.state = {};
    _this.modalRef = /*#__PURE__*/_react["default"].createRef();
    _this.modalContent = "";
    window.addEventListener("resize", function () {
      _this.onResize();
    });
    return _this;
  }
  _createClass(DefaultView, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      this.setState(_objectSpread(_objectSpread({}, this.state), {}, {
        nextProps: nextProps
      }));
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      //this.adjustScrollWidth();
    }
  }, {
    key: "scrollContent",
    value: function scrollContent() {
      document.getElementById("content").scrollLeft = document.getElementById("scroll-duplicate").scrollLeft;
    }
  }, {
    key: "scrollDuplicate",
    value: function scrollDuplicate(e) {
      // console.log('e.target',e.target)
      var content = document.getElementById("content");
      var clientWidth = content.clientWidth;
      var offsetWidth = content.offsetWidth;
      var scrollWidth = content.scrollWidth;
      document.getElementById("scroll-duplicate").scrollLeft = content.scrollLeft;
    }
  }, {
    key: "onResize",
    value: function onResize() {
      var filler = document.getElementById("scroll-duplicate-filler");
      var mask = document.getElementById("scroll-duplicate-mask");
      var content = document.getElementById("content");
      filler.style.width = content.scrollWidth + "px";
    }
  }, {
    key: "adjustScrollWidth",
    value: function adjustScrollWidth() {
      var filler = document.getElementById("scroll-duplicate-filler");
      var mask = document.getElementById("scroll-duplicate-mask");
      var content = document.getElementById("content");
      var duplicate = document.getElementById("scroll-duplicate-container");
      if (duplicate) {
        duplicate.style.opacity = 0;
        setTimeout(function () {
          filler.style.width = content.scrollWidth + "px";
          duplicate.style.opacity = 1;
        }, 300);
      }
    }
  }, {
    key: "showScroll",
    value: function showScroll() {
      var filler = document.getElementById("scroll-duplicate-filler");
      var mask = document.getElementById("scroll-duplicate-mask");
      var content = document.getElementById("content");
      var duplicate = document.getElementById("scroll-duplicate");
      filler.style.width = content.scrollWidth + "px";
      if (navigator.userAgent.toLowerCase().indexOf("firefox") > -1) {
        content.scrollLeft += 1;
        content.scrollLeft -= 1;
        duplicate.scrollLeft += 1;
        duplicate.scrollLeft -= 1;
      }
      mask.className = "hidden";
    }
  }, {
    key: "hideScroll",
    value: function hideScroll() {
      var mask = document.getElementById("scroll-duplicate-mask");
      mask.className = "";
    }
  }, {
    key: "scrollCheck",
    value: function scrollCheck(e) {
      // console.log('scrollCheck e.target',e.target)
    }
  }, {
    key: "showVerticalScroll",
    value: function showVerticalScroll(e) {
      if (navigator.userAgent.toLowerCase().indexOf("firefox") > -1) {
        var contentScroller = document.getElementById("contentScroller");
        contentScroller.scrollTop += 1;
        contentScroller.scrollTop -= 1;
      }
    }
  }, {
    key: "renderModalContent",
    value: function renderModalContent(content) {
      modalContent = content;
      this.modalRef.current.update();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      setTimeout(function () {
        _this2.adjustScrollWidth();
      }, 0);
      return /*#__PURE__*/_react["default"].createElement("div", {
        id: "defaultView",
        key: "defaultView"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        id: "mobileMask",
        onClick: function onClick() {
          var elem1 = document.getElementById("navigationDrawer");
          var elem2 = document.getElementById("mobileMask");
          elem1.classList.remove("visible");
          elem2.className = "";
        }
      }), /*#__PURE__*/_react["default"].createElement(_navigationDrawer["default"], {
        id: "navigationDrawer",
        appTitle: this.props.appTitle,
        userName: this.props.userName,
        userAvatar: this.props.userAvatar,
        userAction: this.props.userAction,
        signOut: this.props.signOut,
        menuItems: this.props.menuitems,
        allAppsItems: _allAppsItems.allAppsItems,
        hideAllAppsMenu: this.props.hideAllAppsMenu,
        adjustScrollWidth: function adjustScrollWidth() {
          return _this2.adjustScrollWidth();
        },
        modal: function modal(e) {
          return _this2.renderModalContent(e);
        },
        createDemoMenu: this.props.createDemoMenu
      }), /*#__PURE__*/_react["default"].createElement("div", {
        id: "contentContainer",
        key: "contentContainer",
        onScroll: function onScroll(e) {
          return _this2.scrollCheck(e);
        },
        onMouseOver: function onMouseOver(e) {
          return _this2.showVerticalScroll(e);
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        id: "contentFrameFixer",
        onScroll: function onScroll(e) {
          return _this2.scrollCheck(e);
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        id: "contentFrameScrollbarMask"
      }), /*#__PURE__*/_react["default"].createElement("div", {
        id: "contentScroller",
        onScroll: function onScroll(e) {
          return _this2.scrollCheck(e);
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        id: "header",
        key: "HeaderContainer"
      }, /*#__PURE__*/_react["default"].createElement(_turingHeader["default"], {
        key: "HeaderContent",
        backButton: this.props.backButton,
        backButtonHandler: this.props.backButtonHandler,
        backButtonState: this.props.backButtonState,
        title: this.props.title,
        menuItems: this.props.menuitems,
        featuredFunctions: this.props.featuredFunctions,
        contextPanel: this.props.contextPanel
      })), /*#__PURE__*/_react["default"].createElement("div", {
        id: "scroll-duplicate-container",
        key: "scroll-duplicate-container",
        onMouseOver: function onMouseOver() {
          return _this2.showScroll();
        },
        onMouseOut: function onMouseOut() {
          return _this2.hideScroll();
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        id: "scroll-duplicate-mask",
        key: "scroll-duplicate-mask"
      }), /*#__PURE__*/_react["default"].createElement("div", {
        id: "scroll-duplicate",
        key: "scroll-duplicate",
        onScroll: function onScroll() {
          return _this2.scrollContent();
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        id: "scroll-duplicate-filler",
        key: "scroll-duplicate-filler"
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        id: "pageContentContainer",
        onScroll: function onScroll(e) {
          return _this2.scrollDuplicate(e);
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        id: "content-scroll-mask"
      }), /*#__PURE__*/_react["default"].createElement("div", {
        id: "content",
        onScroll: function onScroll(e) {
          return _this2.scrollDuplicate(e);
        },
        onMouseOver: function onMouseOver() {
          return _this2.showScroll();
        },
        onMouseOut: function onMouseOut() {
          return _this2.hideScroll();
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        id: "contentPadding",
        key: "contentPadding"
      }, this.props.content || this.props.children))), /*#__PURE__*/_react["default"].createElement(_turingFooter["default"], {
        backgroundColor: "#f0f0f0"
      })))), /*#__PURE__*/_react["default"].createElement("div", {
        id: "debuggingPanel"
      }, this.props.debuggingPanel, " "), /*#__PURE__*/_react["default"].createElement("div", {
        id: "topPanel"
      }, this.props.topPanel, " "), /*#__PURE__*/_react["default"].createElement(MobileButton, null), /*#__PURE__*/_react["default"].createElement("div", {
        id: "notificationsPanel"
      }, this.props.notificationsPanel, " "), /*#__PURE__*/_react["default"].createElement("div", {
        id: "rightDrawer"
      }, this.props.rightDrawer), /*#__PURE__*/_react["default"].createElement("div", {
        id: "statusPanel"
      }, this.props.statusPanel), /*#__PURE__*/_react["default"].createElement("div", {
        id: "modals"
      }, /*#__PURE__*/_react["default"].createElement(Modal, {
        ref: this.modalRef
      })));
    }
  }]);
  return DefaultView;
}(_react["default"].Component);
var Modal = /*#__PURE__*/function (_React$Component2) {
  _inherits(Modal, _React$Component2);
  var _super2 = _createSuper(Modal);
  function Modal(props) {
    var _this3;
    _classCallCheck(this, Modal);
    _this3 = _super2.call(this, props);
    _this3.state = {};
    return _this3;
  }
  _createClass(Modal, [{
    key: "update",
    value: function update() {
      this.setState({});
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement("div", null, modalContent);
    }
  }]);
  return Modal;
}(_react["default"].Component);
var MobileButton = function MobileButton(props) {
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    className: "material-icons-round",
    id: "mobileButton",
    onClick: function onClick() {
      var elem1 = document.getElementById("navigationDrawer");
      var elem2 = document.getElementById("mobileMask");
      if (elem1.className === "drawerCollapsed") elem1.className = "drawerMainMenu";
      elem1.classList.add("visible");
      elem2.className = "visible";
    }
  }, "menu");
};
var MobilePanel = function MobilePanel(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    id: "mobilePanel"
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    className: "material-icons-round",
    style: {
      fontSize: "28px",
      cursor: "pointer"
    },
    onClick: function onClick() {
      var elem = document.getElementById("mobileMask");
      elem.className = "visible";
    }
  }, "menu"), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("h1", null, "Turing"), props.appTitle && /*#__PURE__*/_react["default"].createElement("h2", null, props.appTitle)), /*#__PURE__*/_react["default"].createElement(_antd2.Avatar, {
    icon: "user",
    src: props.userAvatar
  }));
};
var _default = exports["default"] = DefaultView;